import type { Flag } from '@/state/flags/flag-types';
import { FlagSection } from './FlagSection';
import { FLAG_COPY } from '../copy';

type FlagPayloadsProps = { flag: Flag };

const COPY = FLAG_COPY.payloads;

const payloadText = (payload: unknown) =>
  payload === null || payload === undefined ? null : JSON.stringify(payload, null, 2);

/**
 * A code flag's two sides and the JSON each sends with it, read only: they are set in the
 * create dialog. An editor flag has no payloads; its On side is the Changes card.
 */
export const FlagPayloads = ({ flag }: FlagPayloadsProps) => {
  const sides = [
    { label: FLAG_COPY.guardrail.off, payload: flag.variants.find((variant) => variant.key === 'off')?.payload },
    { label: FLAG_COPY.guardrail.on, payload: flag.variants.find((variant) => variant.key === 'on')?.payload },
  ];

  return (
    <FlagSection title={COPY.title} help={COPY.help} description={COPY.description} tourAnchor="flag-payloads">
      <div className="grid gap-3 sm:grid-cols-2">
        {sides.map(({ label, payload }) => {
          const text = payloadText(payload);
          return (
            <div key={label} className="border-line rounded-card flex min-w-0 flex-col gap-1.5 border p-3">
              <span className="text-foreground text-body font-medium">{label}</span>
              {text ? (
                <pre className="text-dim m-0 overflow-x-auto font-mono text-micro whitespace-pre">{text}</pre>
              ) : (
                <span className="supporting">{COPY.none}</span>
              )}
            </div>
          );
        })}
      </div>
    </FlagSection>
  );
};
